import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VacayRedirectGuard implements CanActivate {
  canActivate(): boolean {
    window.location.href = '/vacay';
    return false; // Prevent Angular from continuing navigation
  }
}
